// visitor.js
import { useEffect } from 'react';

function Visitor() {
  useEffect(() => {
    window.location.href = 'https://perfectdatas.in/isjs/visitor'; // <-- your third-party URL
  }, []);

  return null; // Or you can return a "Redirecting..." message or spinner
}

export default Visitor;
